module.exports = "/_next/static/images/ly-e707148ffd5f1cdafa70117b685faff7.svg";